<template>
	<div>
		<section>
			<aside class="left_sidebar" id="sidenav" @mouseover="sideOver" @mouseleave="sideDown" ref="sidenav">
				<Header ref="header"></Header>
				<div class="left_nav_wrap">
					<SubMenu :stock_changed="stock_changed" :headers="headers"></SubMenu>
				</div>
			</aside>
		</section>
		<section class="content_wrap" id="content_wrap">
			<div class="content_top_title">
				<!-- <h3>${subTitle!}</h3> -->
				<h3>{{ subTitle }}</h3>
				<div class="page_nav_box">
					<span>{{ subTitle }}</span>
				</div>
			</div>
			<div class="content_area">
				<!-- <#nested/> -->
				<router-view :key="$route.fullPath" :headers="headers"></router-view>
			</div>
			<report-viewer></report-viewer>
		</section>
		<!-- <bottom-menu></bottom-menu>
		<left-menu></left-menu>

		<section class="content_wrap">
			<top-menu></top-menu>
			<router-view></router-view>
		</section> -->

		<!-- <div>{{ username }}</div>
		<div><a v-on:click="logout" href="javascript:void(0)">로그아웃</a></div> -->
		<bwise-feedback-host :bwise-visible="admin" />
	</div>
</template>

<script>
require('@/assets/css/layout.css');
require('@/assets/css/global.css');
import '@/assets/css/table_box.css';
import Chart from 'chart.js';
import { apiSessionCheck, apiSystemMessage } from '@/api/index';
import Header from '@/components/common/Header';
import SubMenu from '@/components/common/SubMenu';
import ReportViewer from '@/components/common/ReportViewer';
// import TopMenu from '@/components/common/TopMenu.vue';
// import leftMenu from '@/components/common/LeftMenu.vue';
// import bottomMenu from '@/components/common/BottomMenu.vue';
import { apiGetUsername } from '@/api/auth';

//import { initDatepicker } from '@/utils/date';

export default {
	data: function() {
		return {
			// username: '',
			stock_changed: false,
		};
	},
	computed: {
		headers: function() {
			//return this.$session.get('headerClass');
			return {
				class: this.$session.get('headerClass'),
			};
		},
		subTitle: function() {
			let title = this.$route.meta.subTitle;
			if (title === undefined) {
				title = this.$store.getters.getSubTitle;
			}
			return title;
		},
		admin: function() {
			return this.$session.get('user').admin;
		},
		env: function() {
			return process.env.NODE_ENV;
		},
	},
	components: {
		Header,
		SubMenu,
		ReportViewer,
		// 'top-menu': TopMenu,
		// 'left-menu': leftMenu,
		// 'bottom-menu': bottomMenu,
	},
	methods: {
		async getUsername() {
			var { data } = await apiGetUsername();
			console.log(data);
			this.username = data.username;
			this.stock_changed = data.stock_changed;
		},
		async sessionCheck() {
			await apiSessionCheck();
			//const { data } = await apiSessionCheck();
			//console.log(data);
		},
		async messageCheck() {
			//console.log('message check');
			const { data } = await apiSystemMessage();
			//console.log(data);
			if (data.msg) {
				this.$toast.clear();
				this.$toast.error(data.msg, { duration: 50000 });
			}
		},
		getSideValue() {
			let value = localStorage.getItem('sideValue');
			return value === null ? true : value !== 'false';
		},
		sideOver() {
			let sideValue = this.getSideValue();
			if (sideValue === false) {
				this.$refs.sidenav.style.width = '234px';
				this.$refs.header.$refs.company_name.style.marginTop = '0px';
			}
		},
		sideDown() {
			let sideValue = this.getSideValue();
			if (sideValue === false) {
				this.$refs.sidenav.style.width = '47px';
				this.$refs.header.$refs.company_name.style.marginTop = '-52px';
			}
		},
		customToolTip() {
			/* Custom positioner */
			// const tooltipPlugin = Chart.registry.getPlugin('tooltip');
			Chart.Tooltip.positioners.bottom = function(items) {
				const pos = Chart.Tooltip.positioners.average(items);

				// Happens when nothing is found
				if (pos === false) {
					return false;
				}
				// console.log(this); // ChartElement
				const chart = this._chart;

				return {
					x: pos.x,
					y: chart.chartArea.bottom,
				};
			};
		},
	},
	mounted() {
		setInterval(() => {
			//console.log('5초마다 동작');
			this.sessionCheck();
		}, 3 * 60 * 60 * 1000); //3시간

		//console.log(this.env);

		// if (this.env == 'test') {
		// 	setInterval(() => {
		// 		this.messageCheck();
		// 	}, 60 * 1000); //1분
		// }
		//}, 40 * 60 * 1000); //40분
		//
		window.Stimulsoft.Base.StiLicense.key =
			'6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHlvUL3peL5IevKtXfH/ibLTiBazDgF0i48eBaoe2NtJeZ+A7K' +
			'oilhfGTl1YIQv3Qndk4RmG7pGsKtbeRWmqetGZ+sFqLfLh/ICRcPfmwyTGJVGzfQStiYR6Juc35mBmhHGDbdeWFq3C' +
			'4kjQ70lWTfTqo7v/PcZ5QBAEoHjtpEfrSNvwlS/Hthy1yHhQwjNBAEPXqvNwcPc+3gIXBHZDe5fvTN/eOg4Imv7nW6' +
			'YnX9+mm1tHJMML+N2joKBk6Ag1V5itqyDeDpllo/sYkXtDnqBbwq16VA8m4Mm73BlnRtFkx3ulKAuBB9kPjkeHI9N1' +
			'CUqyPALCq4aMm32U4Jr/QjNPhABnBCuUlQK5mPROX1V7zG5lZNBPhF6SUVQO4LHll49oIzjRwCQrWi5nk27+orlIPe' +
			'5nFTSYR8+ptV4rpuX4ebCAwmec1TOT+VAy3ESAqYTbVNEpJOUEBxZEa6PcDzRM+84MuXaZ642YNfwTt5wogwMnPSnD' +
			'GJpPJOS+Vf++KlvXWXKJ8YhXD0xKuextpfSM';
		// const license = require('../assets/license/stimulsoft-license.key');
		// window.Stimulsoft.Base.StiLicense.loadFromFile(license);
		//initDatepicker();
		// $("input[type='text'], input[type='number'").on('focus', function() {
		// 	$(this).select();
		// });
		// $("input[type='text'], input[type='number'").on('click', function() {
		// 	console.log('click');
		// 	$(this).select();
		// });
		// $('.date, .date_int').datepicker({
		// 	dateFormat: 'yy-mm-dd',
		// 	onSelect: function() {
		// 		$(this)[0].dispatchEvent(new Event('input', { bubbles: true }));
		// 	},
		// });
		// $("input[type='text'], input[type='number'").on('click', function() {
		// 	$(this).select();
		// });
	},
	created() {
		//console.log('man page');
		//this.$store.sideIndex = 0;
		//const user = this.$session.get('user');
		//console.log(user);
		//this.getUsername();
		//console.log('calling from mainpage');
		this.customToolTip();

		setTimeout(function() {
			$('body').addClass('loaded');
		}, 0);
		this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
};
</script>

<style lang="scss"></style>
